import { PurchaseAreaUpdatePage } from "@/features/purchase-area/pages/PurchaseAreaUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/purchase-area/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["purchase_area.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PurchaseAreaUpdatePage,
});
